import { render, staticRenderFns } from "./AttributeWrapperForEditableComponent.vue?vue&type=template&id=1cd5f907&scoped=true"
import script from "./AttributeWrapperForEditableComponent.vue?vue&type=script&lang=js"
export * from "./AttributeWrapperForEditableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd5f907",
  null
  
)

export default component.exports